/**
 * Loading Grid Component
 *
 * Shimmer loading skeleton for content grids.
 */

export function LoadingGrid() {
  return (
    <div className="space-y-8 px-4 py-4">
      {/* Section 1 */}
      <div>
        <div className="h-6 w-32 shimmer rounded mb-4" />
        <div className="flex gap-4 overflow-hidden">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="shrink-0 w-36">
              <div className="aspect-square shimmer rounded-xl mb-3" />
              <div className="h-4 w-full shimmer rounded mb-2" />
              <div className="h-3 w-2/3 shimmer rounded" />
            </div>
          ))}
        </div>
      </div>

      {/* Section 2 */}
      <div>
        <div className="h-6 w-40 shimmer rounded mb-4" />
        <div className="flex gap-4 overflow-hidden">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="shrink-0 w-36">
              <div className="aspect-square shimmer rounded-xl mb-3" />
              <div className="h-4 w-full shimmer rounded mb-2" />
              <div className="h-3 w-1/2 shimmer rounded" />
            </div>
          ))}
        </div>
      </div>

      {/* Section 3 - List */}
      <div>
        <div className="h-6 w-28 shimmer rounded mb-4" />
        <div className="space-y-3">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-12 h-12 shimmer rounded-lg" />
              <div className="flex-1">
                <div className="h-4 w-3/4 shimmer rounded mb-2" />
                <div className="h-3 w-1/2 shimmer rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
